import React, { Component } from 'react';
import { Col , Row , Divider} from 'antd';


const ObjectDescription = (data,col) => {
 return  Object.keys(data).map( key => <Col key={key} span={24/col}> {key} : <span style={{fontWeight:"bold"}}> {data[key]} </span></Col>)
}

const ArrayDescription = (data,col) => {
    return data.map((obj,index) => <Row key={index}  style={data.length !== 1 && {borderBottom:"1px solid #ededed"}}>{ObjectDescription(obj,col)}</Row>)
}


class Description extends Component {
  
    static defaultProps = {
        title : "Description Title",
        col : 3,
        data : [{
            "Test" : "Test VAleu",
            "Test 2" : "test value 2",
            "Test 4" : "test value 2",
            "Test 5" : "test value 2"

        }
    ]
    }

    render() { 
        return ( 
     
        <Row data-testid= "data-description">
            <h3 data-testid="data-description-title" style={{borderBottom:"1px solid lightGray"}}>{this.props.title}</h3>
            {
                Array.isArray(this.props.data) ? ArrayDescription(this.props.data,this.props.col): ObjectDescription(this.props.data,this.props.col)       
            }
           
        </Row>
        );
    }
}
 
export default Description;